import { render, staticRenderFns } from "./ponent-popup.vue?vue&type=template&id=7a9f8aec&"
import script from "./ponent-popup.vue?vue&type=script&lang=js&"
export * from "./ponent-popup.vue?vue&type=script&lang=js&"
import style0 from "./ponent-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports